import { Facebook, Twitter, Linkedin, Instagram, Phone, Mail, MapPin } from "lucide-react";

import footlogo from "../assets/l2.png";
import bgPng from "../assets/Bagcc.webp"; // ✅ background image
import topStrip from "../assets/foottopimg2.webp"; // <-- ⭐ apna tree wala png

const Footer = () => {
  return (
    <>
       <div className="w-full overflow-hidden">
        <img 
          src={topStrip} 
          alt="decorative strip" 
          className="w-full object-cover -mt-1" 
        />
      </div>
       <footer
      className="relative text-black text-md bg-cover bg-top"
      style={{ backgroundImage: `url(${bgPng})` }}
    >
         {/* ⭐ Top Decorative Strip */}
   
      {/* Overlay with gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-green-500/40 to-green-600/60"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Logo & About */}
        <div className="space-y-4">
          <div className="flex bg-white items-center h-16 w-16 shadow-lg">
            <img
              src={footlogo}
              alt="Logo"
              className="h-full w-full object-contain"
            />
          </div>
          <p className="text-gray-900 leading-relaxed">
            Empowering agriculture through technology and innovation.
          </p>

          {/* Social Icons */}
          <div className="flex space-x-3">
            {[
              { Icon: Twitter, color: "bg-white hover:text-blue-600" },
              { Icon: Facebook, color: "bg-white hover:text-blue-800" },
              { Icon: Linkedin, color: "bg-white hover:text-blue-500" },
              { Icon: Instagram, color: "bg-white hover:text-pink-700" },
            ].map(({ Icon, color }, idx) => (
              <a
                key={idx}
                href="#"
                className={`${color} p-2 rounded-full shadow-md transition transform hover:scale-110`}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-2">Contact Us</h4>
          {/* Border line */}
          <span className="block w-auto h-[2px] bg-[#055e28] mb-4 relative overflow-hidden">
            <span className="absolute top-0 left-[-10%] w-4 h-2 bg-white rounded-sm animate-slide" />
          </span>

          <ul className="space-y-3 text-gray-900">
            <li className="flex items-start gap-2">
              <MapPin className="text-[#ffffff] w-14 h-14 mt-0.5" />
              <span>
                Unit No 22, Sector 1, Millennium Business Park, Mahape, Navi
                Mumbai, 400710
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="text-[#ffffff] w-5 h-5" />
              <span>mail@precisiongrow.co.in</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="text-[#ffffff] w-5 h-5" />
              <span>+91 80972 83444</span>
            </li>
          </ul>
        </div>

        {/* Menu Links */}
        <div>
          <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
          {/* Border line */}
          <span className="block w-auto h-[2px] bg-[#055e28] mb-4 relative overflow-hidden">
            <span className="absolute top-0 left-[-10%] w-4 h-2 bg-white rounded-sm animate-slide" />
          </span>

          <ul className="space-y-2 text-gray-900">
            <li>
              <a href="#" className="hover:text-[#ffffff]">Home</a>
            </li>
            <li>
              <a href="#" className="hover:text-[#ffffff]">About</a>
            </li>
            <li>
              <a href="#" className="hover:text-[#ffffff]">Services</a>
            </li>
            <li>
              <a href="#" className="hover:text-[#ffffff]">Contact</a>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="text-lg font-semibold mb-2">Newsletter</h4>
          {/* Border line */}
          <span className="block w-auto h-[2px] bg-[#055e28] mb-4 relative overflow-hidden">
            <span className="absolute top-0 left-[-10%] w-4 h-2 bg-white rounded-sm animate-slide" />
          </span>

          <p className="text-gray-900 text-md mb-4">
            Subscribe to get the latest updates and news from Drone Didi.
          </p>
          <form className="flex items-center">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-3 py-2 rounded-l-md bg-white/70 text-white text-sm focus:outline-none"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-[#055e28] hover:bg-[#035524] text-white rounded-r-md text-sm font-medium transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Bottom */}
      <div className="relative text-center text-gray-900 py-4 text-md border-t border-white/40">
        © {new Date().getFullYear()} All rights reserved.
      </div>

    
    </footer>
    </>
   
  );
};

export default Footer;
